// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header .rect2 {
  width: 3px;
  height: calc(16 * var(--width-ratio));
  background: var(--ion-color-primary-tint);
  border-radius: 10px;
  margin-right: 5px;
}

#swiper_related_products .swiper-wrapper {
  margin-top: 6px;
  width: 100%;
}
#swiper_related_products .swiper-slide {
  width: calc(120 / var(--base-width) * 100vw);
}
#swiper_related_products .swiper-slide .image-container {
  width: calc(120 * var(--width-ratio));
  height: calc(120 * var(--width-ratio));
}
#swiper_related_products .swiper-slide .myImage {
  width: 100%;
  height: 100%;
  background-position: center !important;
  background-size: cover !important;
  background-image: url("/assets/img/default/ec_commodity_default.png");
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}
#swiper_related_products .swiper-slide .flex {
  display: flex;
  flex-direction: column;
}
#swiper_related_products .swiper-slide .flex1 {
  align-items: center;
  justify-content: center;
  display: flex;
}
#swiper_related_products .swiper-slide .flex2 {
  align-items: center;
  justify-content: center;
  display: flex;
  width: calc(120 / var(--base-width) * 100vw);
  height: calc(44 * var(--width-ratio));
  margin: auto;
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/related-product/related-product.component.scss"],"names":[],"mappings":"AACE;EACE,UAAA;EACA,qCAAA;EACA,yCAAA;EACA,mBAAA;EACA,iBAAA;AAAJ;;AAKE;EACE,eAAA;EAEA,WAAA;AAHJ;AAME;EACE,4CAAA;AAJJ;AAMI;EACE,qCAAA;EACA,sCAAA;AAJN;AAOI;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,iCAAA;EACA,qEAAA;EAEA,4BAAA;EACA,6BAAA;EACA,gCAAA;EACA,+BAAA;AANN;AASI;EACE,aAAA;EACA,sBAAA;AAPN;AAUI;EACE,mBAAA;EACA,uBAAA;EACA,aAAA;AARN;AAWI;EACE,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,4CAAA;EACA,qCAAA;EACA,YAAA;EACA,eAAA;AATN","sourcesContent":[".header {\n  .rect2 {\n    width: 3px;\n    height: calc(16 * var(--width-ratio));\n    background: var(--ion-color-primary-tint);\n    border-radius: 10px;\n    margin-right: 5px;\n  }\n}\n\n#swiper_related_products {\n  .swiper-wrapper {\n    margin-top: 6px;\n    // padding-left: 26px;\n    width: 100%;\n  }\n\n  .swiper-slide {\n    width: calc(120 / var(--base-width) * 100vw);\n\n    .image-container {\n      width: calc(120 * var(--width-ratio));\n      height: calc(120 * var(--width-ratio));\n    }\n\n    .myImage {\n      width: 100%;\n      height: 100%;\n      background-position: center !important;\n      background-size: cover !important;\n      background-image: url(\"/assets/img/default/ec_commodity_default.png\");\n\n      border-top-left-radius: 20px;\n      border-top-right-radius: 20px;\n      border-bottom-right-radius: 10px;\n      border-bottom-left-radius: 10px;\n    }\n\n    .flex {\n      display: flex;\n      flex-direction: column;\n    }\n\n    .flex1 {\n      align-items: center;\n      justify-content: center;\n      display: flex;\n    }\n\n    .flex2 {\n      align-items: center;\n      justify-content: center;\n      display: flex;\n      width: calc(120 / var(--base-width) * 100vw);\n      height: calc(44 * var(--width-ratio));\n      margin: auto;\n      margin-top: 4px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
